import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
(
    <Suspense fallback={<SuspenseLoader />}>
        <Component {...props} />
    </Suspense>
);

// Dashboards

const DashboardDrive = Loader(
    lazy(() => import('src/content/driver/Dashboard'))
);

const Statistics = Loader(
    lazy(() => import('src/content/dashboards/Statistics'))
);

const Events = Loader(lazy(() => import('src/content/driver/Event')));
const Notification = Loader(lazy(() => import('src/content/driver/Notification')));

const driverRoutes = [
    {
        path: '/',
        element: <Navigate to="dashboard" replace />
    },
    {
        path: 'dashboard',
        element: <DashboardDrive />
    },
    {
        path: 'events',
        element: <Events />
    },
    {
        path: 'notifications',
        element: <Notification />
    },
];

export default driverRoutes;
